/**
 * Conecta el api client con el auth store (token + onUnauthorized handler).
 * Importar esto una vez al arrancar la app (en App.tsx) antes de hacer requests.
 */

import { configureApi } from "./api.ts";
import { useAuthStore } from "@/stores/auth.ts";
import { useCompanyStore } from "@/stores/company.ts";
import { useTerminalStore } from "@/stores/terminal.ts";

let configured = false;

/** Flag que LoginPage lee para mostrar "Tu sesión expiró". Se limpia al hacer
 *  login. sessionStorage en lugar de state de React: el handler corre fuera
 *  del árbol de componentes y necesita persistir el aviso a través del reload. */
export const SESSION_EXPIRED_KEY = "pos.session_expired";

export function setupApi(): void {
  if (configured) return;
  configureApi({
    getToken: () => useAuthStore.getState().token,
    getTerminalId: () => useTerminalStore.getState().terminal?.id ?? null,
    getTenantRuc: () => useCompanyStore.getState().ruc,
    onUnauthorized: () => {
      // Si ya está limpio (no había token), no es expiración: es un endpoint
      // protegido al que se accedió sin auth. No marcar el flag ni reload.
      const hadToken = useAuthStore.getState().token != null;
      useAuthStore.getState().clearSession();

      if (hadToken && !window.location.pathname.endsWith("/login")) {
        sessionStorage.setItem(SESSION_EXPIRED_KEY, "1");
        // Reload directo: garantiza que cualquier componente con estado intermedio
        // (PaymentDialog en plena emisión, etc.) se desmonte limpio. El navigate
        // del router no se puede invocar fuera del árbol de React.
        window.location.replace("/login");
      }
    },
  });
  configured = true;
}
